import { useEffect, useState } from 'react'
import classNames from 'classnames'

import ScrollHandler from '../ScrollHandler/ScrollHandler'
import Image from '../Image/Image'
import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../../utils'

import styles from './ContactListing.module.scss'
import mapIcon from '../../../assets/images/Map.svg'
import emailicon from '../../../assets/images/emailicon.svg'
import phoneicon from '../../../assets/images/phoneicon.svg'
import { ContactUsConstants } from '../../../Contansts'

const ContactListing = ({ section2 }) => {
  const { language } = useLanguage()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAtStart, setIsAtStart] = useState(true)
  const [isAtEnd, setIsAtEnd] = useState(false)

  const contacts = section2?.contactDetails
  const location = section2?.location

  useEffect(() => {
    if (currentIndex === 0) {
      setIsAtStart(true)
    }
    if (currentIndex === location?.length - 1) {
      setIsAtEnd(true)
    }
  }, [currentIndex, location?.length])

  const handleNext = () => {
    if (currentIndex < location?.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1)
      setIsAtStart(false)
    }
  }
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1)
      setIsAtEnd(false)
    }
  }

  const getIcon = (type) => {
    switch (type) {
      case ContactUsConstants?.email:
        return emailicon
      case ContactUsConstants?.call:
        return phoneicon
      default:
        return
    }
  }

  const renderAnswer = (contact) => {
    return (
      <a
        key={contact?.question}
        href={
          contact?.key === ContactUsConstants?.email
            ? `mailto:${contact?.answer}`
            : `tel:${contact?.answer}`
        }
        className={classNames(styles.contactValue)}
      >
        <Image
          src={getIcon(contact?.key)}
          alt="contact"
          className={styles.contactIcon}
        />
        <div className={classNames(styles.contactTextContainer)}>
          <span className={styles.contactlabel}>{contact?.question}</span>
          <span className={classNames(styles.answer)}>{contact?.answer}</span>
        </div>
      </a>
    )
  }

  const viewMapClickHandler = (details) => {
    const address = details?.mapaddress
    const googleMapsUrl = `${details.link.path}?q=${encodeURIComponent(address)}`
    window.open(googleMapsUrl, '_blank')
    // `https://www.google.com/maps/search/?api=1&query=19.142820897898766,72.85450601962846`,
  }

  return (
    <div
      className={classNames(
        'grid-cols-1 lg:mb-36 mb-14',
        styles.rootContainer,
        { [styles.arabicRootContainer]: isArabic(language?.code) }
      )}
    >
      <div className={styles.contactRootContainer}>
        <h1 className={classNames(styles['title'])}>{section2?.title}</h1>
        <div className={styles.contactsContainer}>
          {contacts?.map((contact) => {
            return renderAnswer(contact)
          })}
        </div>
        <div className={classNames(styles['scrollbtn'])}>
          <ScrollHandler
            scrollLeftHandler={
              isArabic(language?.code) ? handleNext : handlePrev
            }
            scrollRightHandler={
              isArabic(language?.code) ? handlePrev : handleNext
            }
            isAtStart={isAtStart}
            isAtEnd={isAtEnd}
          />
        </div>
      </div>

      <div className={styles.carouselcontainer}>
        <div className={styles.carousel}>
          {location?.map((data, index) => (
            <div
              key={'location' + data?.id}
              className={classNames(
                styles['carouselcard'],
                styles[index === currentIndex ? 'active' : ''],
                styles[
                  index === (currentIndex + 1) % location.length ? 'next' : ''
                ],
                { ['cursor-pointer']: data?.link }
              )}
            >
              <div className={classNames(styles['cardInnerContainer'])}>
                <p className={styles.cityText}>{data?.title}</p>
                <p className={styles.addresText}>{data?.description}</p>
              </div>
              {data?.link && (
                <div
                  className={classNames(
                    styles['bottom-container'],
                    ' w-full flex justify-between items-center overflow-visible'
                  )}
                >
                  <p className={styles.mapLink}>{data?.link?.label}</p>
                  <button
                    className={classNames(
                      styles['animated-action-wrapper'],
                      'bg-white relative'
                    )}
                    onClick={() => viewMapClickHandler(data)}
                  >
                    <img
                      src={mapIcon}
                      alt="Arrow"
                      className={classNames(
                        styles['action-image'],
                        'block cursor-pointer'
                      )}
                    />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default ContactListing
